<template>
  <div class="human-resource">
    <div style="position: relative">
      <titleInternal titleName="小循环处置时效分布"></titleInternal>
      <el-radio-group
        v-model="tabPosition"
        class="special-radio"
        size="mini"
        @input="inputChange"
      >
        <el-radio-button label="top">责任确认时效</el-radio-button>
        <el-radio-button label="left">整改时效</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="tabPosition == 'top'" style="width: 404px; height: 230px">
      <wgEchart :options="smallCycleOneList" id="smallCycleOne"></wgEchart>
    </div>
    <div v-if="tabPosition == 'left'" style="width: 404px; height: 230px">
      <wgEchart :options="smallCycleTwoList" id="smallCycleTwo"></wgEchart>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreenMini/components/title-internal.vue";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
  },
  props: {
    rlLineList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    wcLineList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    rlLineList: {
      handler(val) {
        this.optionsListData(val, 1);
      },
      deep: true,
    },
    wcLineList: {
      handler(val) {
        this.optionsListData(val, 2);
      },
      deep: true,
    },
  },
  data() {
    return {
      tabPosition: "top",
      smallCycleOneList: {},
      smallCycleTwoList: {},
    };
  },
  mounted() {
    this.optionsListData(this.rlLineList, 1);
    this.optionsListData(this.wcLineList, 2);
  },
  methods: {
    optionsListData(dataList, type) {
      let dataX = dataList.map((item) => item.label);
      let dataY = dataList.map((item) => item.value);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          formatter: function (param) {
            let res = param[0].name;
            for (let j = 0; j < param.length; j++) {
              // 渐变色导致提示框中颜色消失,额外定义
              res += ": " + param[j].value + "<br>";
            }
            return res;
          },
        },
        legend: {
          show: false,
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "10%",
          top: "14%",
          containLabel: true,
        },
        xAxis: {
          data: dataX,
          type: "category",
          axisLine: {
            symbol: "none",
            lineStyle: {
              color: "#50637A",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontSize: 15,
              color: "#ADC2D3",
            },
            // interval: 0,
            // rotate: 40,
            //多出字可以省略显示成点
            formatter: function (params) {
              var index = 3; //字数为6个超出就显示成点
              var newstr = "";
              for (var i = 0; i < params.length; i += index) {
                var tmp = params.substring(i, i + index);
                newstr += tmp + "";
              }
              if (newstr.length > 3) return newstr.substring(0, 3) + "...";
              else return "\n" + newstr;
            },
          },
        },
        yAxis: {
          name: "小时",
          nameTextStyle: {
            color: "#ADC2D3",
            fontSize: 15,
          },
          type: "value",
          axisLabel: {
            color: "#ADC2D3",
            fontSize: 16,
            padding: [0, 10, 0, 0],
          },
          splitLine: {
            lineStyle: {
              color: "rgba(172, 206, 234, 0.2)",
              type: "dashed",
            },
          },
        },
        dataZoom: [
          {
            // 设置滚动条的隐藏与显示
            show: true,
            // 设置滚动条类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 3,
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 设置滚动条宽度，相对于盒子宽度
            width: "90%",
            // 设置滚动条高度
            height: 8,
            // 设置滚动条显示位置
            left: "center",
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 控制手柄的尺寸
            handleSize: 0,
            // dataZoom-slider组件离容器下侧的距离
            bottom: 3,
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标滚轮触发滚动
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        series: [
          {
            data: dataY,
            type: "line",
            smooth: true,
            color: "rgba(0, 208, 255, 1)",
            lineStyle: {
              width: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0,163,255,0.2)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,163,255,0)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
            showSymbol: false,
          },
        ],
      };
      if (type == 1) {
        this.smallCycleOneList = option;
      } else {
        this.smallCycleTwoList = option;
      }
    },
    inputChange(val) {
      this.optionsListData(val == 'top' ? this.rlLineList : this.wcLineList, val == 'top' ? 1 : 2);
    },
  },
};
</script>
<style scoped lang="less">
.flex-just {
  display: flex;
  justify-content: space-between;
}
.title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 18px;
  color: #f3f8ff;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  background: linear-gradient(180deg, #ddefff 0%, #5bacef 100%);
  color: transparent;
  /* 使用背景渐变填充文字 */
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
  margin: 14px 0 0 12px;
}

.special-radio {
  height: 21px;
  position: absolute;
  top: 5px;
  right: 12px;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
    padding: 4px 6px;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
    padding: 4px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/right/smallCycleDisposal.vue